import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
    IBrand,
    IBrandDropdown,
    IBrandState,
} from "../../../types/brand/brandInterfaces";

export const initialState: IBrandState = {
    brands: [],
    brandsDropdown: [],
    brandSelected: null,
};

export const brandSlice = createSlice({
    name: "brands",
    initialState,
    reducers: {
        loadingBrands: (
            state,
            action: PayloadAction<IBrand[]>
        ) => {
            state.brands = action.payload;
        },

        loadingBrandsDropdown: (
            state,
            action: PayloadAction<IBrandDropdown[]>
        ) => {
            state.brandsDropdown = action.payload;
        },

        deactivateStateBrand: (
            state,
            action: PayloadAction<{
                id: number;
                status: boolean;
            }>
        ) => {
            const { id, status: newState } =
                action.payload;

            state.brands =
                state.brands.map((brand) =>
                    brand.id === id
                        ? {
                            ...brand,
                            status: newState,
                        }
                        : brand
                );
        },

        addBrand: (
            state,
            action: PayloadAction<IBrand>
        ) => {
            state.brands = [
                ...state.brands,
                action.payload,
            ];
        },

        updateBrand: (
            state,
            action: PayloadAction<IBrand>
        ) => {
            state.brands =
                state.brands.map((brand) =>
                    brand.id === action.payload.id
                        ? {
                            ...brand,
                            ...action.payload,
                        }
                        : brand
                );
        },
    },
});

export const {
    loadingBrands,
    loadingBrandsDropdown,
    deactivateStateBrand,
    addBrand,
    updateBrand,
} = brandSlice.actions;

export default brandSlice.reducer;